import { render, staticRenderFns } from "./AdminAnnouncementFormCard.vue?vue&type=template&id=50243d74&scoped=true&"
import script from "./AdminAnnouncementFormCard.vue?vue&type=script&lang=js&"
export * from "./AdminAnnouncementFormCard.vue?vue&type=script&lang=js&"
import style0 from "./AdminAnnouncementFormCard.vue?vue&type=style&index=0&id=50243d74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50243d74",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAutocomplete,VCard,VCardActions,VCardText,VCardTitle,VCol,VContainer,VRow,VSpacer})
